module.exports = __webpack_public_path__ + "static/products-3143cf660a27db6fb5a832d17fcb3b0f.jpg";